import React from "react";

export const SectionHeader: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <div className="costing-section-header">
    <h3>{title}</h3>
    <div className="costing-section-header__actions">{children}</div>
  </div>
);

export const RemoveBtn: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button type="button" className="costing-remove-btn" onClick={onClick}>
    ✕
  </button>
);
